import { gql } from "@apollo/client";

export const GET_ALL_SEVA_SCHEDULES = gql`
  query GetAllSevaSchedules {
    getAllSevaSchedules {
      schedule_id
      seva_type_id
      day_of_week
       notes
      is_active
      createdAt
     am_start_time
am_end_time
pm_start_time
pm_end_time
      sevaTypeDetails{
        seva_type_id
        seva_name
        temple_id
      }
    }
  }
`;


export const GET_SEVA_SCHEDULE_BY_ID = gql`
  query GetSevaScheduleById($schedule_id: ID!) {
    getSevaScheduleById(schedule_id: $schedule_id) {
      schedule_id
      seva_type_id
      day_of_week
        notes
      is_active
      createdAt
      am_start_time
am_end_time
pm_start_time
pm_end_time
    }
  }
`;


export const GET_SEVA_SCHEDULES_BY_SEVA_TYPE_ID = gql`
  query GetSevaSchedulesBySevaTypeId($seva_type_id: ID!) {
    getSevaSchedulesBySevaTypeId(seva_type_id: $seva_type_id) {
      schedule_id
      seva_type_id
      day_of_week
     notes
      is_active
      createdAt
      am_start_time
am_end_time
pm_start_time
pm_end_time
    }
  }
`;

export const CREATE_SEVA_SCHEDULE = gql`
  mutation CreateSevaSchedule($input: createSevaScheduleInput) {
    createSevaSchedule(input: $input) {
      schedule_id
      seva_type_id
      day_of_week
       notes
      is_active
      createdAt
      am_start_time
am_end_time
pm_start_time
pm_end_time
    }
  }
`;


export const UPDATE_SEVA_SCHEDULE = gql`
  mutation UpdateSevaSchedule($input: updateSevaScheduleInput) {
    updateSevaSchedule(input: $input) {
      schedule_id
      seva_type_id
      day_of_week
         notes
      is_active
      am_start_time
am_end_time
pm_start_time
pm_end_time
    }
  }
`;


export const DELETE_SEVA_SCHEDULE = gql`
  mutation DeleteSevaSchedule($schedule_id: ID!) {
    deleteSevaSchedule(schedule_id: $schedule_id)
  }
`;
